import { Box, Button, Flex } from '@ouster/webviz-react-components';

import { FaToolbox } from 'react-icons/fa';

import DashboardCard from './DashboardCard';

type RecordingManagementConsoleProps = {
  handleFetchStale: () => void;
  handleFetchFailed: () => void;
  handleUpdateHWVersion: () => void;
  handleLoadHWMapping: () => void;
  isLoading: boolean;
};

export default function RecordingManagementConsole({
  handleFetchStale,
  handleFetchFailed,
  handleUpdateHWVersion,
  handleLoadHWMapping,
  isLoading,
}: RecordingManagementConsoleProps) {
  return (
    <DashboardCard
      icon={<FaToolbox size={18} />}
      title="Recordings Management Console"
      data-testid="recording-management-console-card"
      style={{ alignContent: 'start', overflow: 'hidden' }}
    >
      <Box display="grid" gap={4} overflow="auto">
        <DashboardCard
          title="Update Drives HW Version"
          description="Using Part to Rev mappings from HW Team"
          data-testid="recording-management-console-update-hw"
        >
          <Flex gap={2} flexWrap="wrap">
            <Button
              minWidth="min-content"
              variant="outline"
              onClick={handleLoadHWMapping}
              flexGrow={1}
            >
              Load HW Mapping
            </Button>
            <Button
              minWidth="min-content"
              variant="outline"
              onClick={handleUpdateHWVersion}
              flexGrow={1}
            >
              Update HW Version
            </Button>
          </Flex>
        </DashboardCard>
        <DashboardCard
          title="Fetch Stale Recordings"
          description="Stale: Processing for over 24 hours."
          data-testid="recording-management-console-fetch-stale"
        >
          <Button
            variant="outline"
            onClick={handleFetchStale}
            disabled={isLoading}
          >
            Fetch Recordings
          </Button>
        </DashboardCard>
        <DashboardCard
          title="Fetch Failed Recordings"
          description="Failed: OSF conversion failed."
          data-testid="recording-management-console-fetch-failed"
        >
          <Button
            variant="outline"
            onClick={handleFetchFailed}
            disabled={isLoading}
          >
            Fetch Recordings
          </Button>
        </DashboardCard>
      </Box>
    </DashboardCard>
  );
}
